module.exports = __webpack_public_path__ + "static/test3-cdf283d0e71d67fcf325264d95fc98a3.jpg";